import { Alert, Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ENTRY_CASES, PATHS } from 'src/constants/navigateRoutes';

/** Explain isolation at the decision point, for every production organization. */
export function OrganizationBoundaryNotice() {
  const { t } = useTranslation();

  return (
    <Alert severity="info">
      <Stack spacing={1} alignItems="flex-start">
        <span>{t('organization_boundary_explanation')}</span>
        <Button
          component={Link}
          to={`${PATHS.onBoardRegistration}?entry=${ENTRY_CASES.joinOrg}`}
        >
          {t('organization_boundary_join')}
        </Button>
      </Stack>
    </Alert>
  );
}
